import { render, staticRenderFns } from "./IntegrationSpedy.vue?vue&type=template&id=d6060748&scoped=true"
import script from "./IntegrationSpedy.vue?vue&type=script&lang=js"
export * from "./IntegrationSpedy.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSpedy.vue?vue&type=style&index=0&id=d6060748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6060748",
  null
  
)

export default component.exports